var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgP22Logo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.48 1.722h7.352V.5H1.577v1.222H6.48zm4.901 1.222h1.226V1.722H.352v1.222h1.225v1.223h9.804V2.944zM10.156 5.39H6.479V6.61H1.577V5.39H.352V4.167h9.804v1.222zM5.254 6.61H.352v1.222h1.225v1.223H6.48V7.833H5.254V6.611zm6.127-2.444h1.226v6.11h1.225V9.057h-1.225V2.944h1.225v1.223h1.226V11.5H8.93v-1.222h2.451V4.167zM.351 9.056h4.903v1.222h1.225V11.5H1.577v-1.222H.352V9.056zM5.255 11.5H.352v1.222h1.225v1.222h11.03v-1.222h1.225V11.5H7.705v1.222H5.254V11.5zm1.225 2.444H.352v1.223h1.225v1.222H6.48v-1.222h4.902v-1.223H6.48zM.352 16.39h4.902v1.222h1.225v1.222H1.577v-1.222H.352V16.39zm4.902 2.444H.352v1.223h1.225v1.222H6.48v-1.223H5.254v-1.222zM.352 21.278h4.902V22.5H.352v-1.222zM16.283 2.944h-1.225v6.112h1.226V2.944z",
    fill: "currentcolor"
  })));
}

export default SvgP22Logo;